// extracted by mini-css-extract-plugin
module.exports = {"section":"Hero_section__8gC3J","container":"Hero_container__3s3u4","body":"Hero_body__2gA_u","title":"Hero_title__2CpbU","text":"Hero_text__2bcjF","image":"Hero_image__1bdSe"};